export default __webpack_public_path__ + "static/bg-donate-e68d1771025dc9b903916f0eff517dac.jpg";